/**
 * @fileoverview Campo da senha do link: mostrar/ocultar, gerar uma senha forte
 * e copiar. A senha fica só no estado do modal (nunca em localStorage ou URL).
 * `readOnly`: só mostrar e copiar (o link recém-criado).
 */

import React, { useState } from "react";
import TextField from "@material-ui/core/TextField";
import Tooltip from "@material-ui/core/Tooltip";
import { Eye, EyeOff, Wand2, Copy, Check } from "lucide-react";

import { i18n } from "../../translate/i18n";
import { useCopyFeedback } from "../../hooks/useCopyFeedback";
import { generateStrongPassword } from "./shareHelpers";
import useStyles from "./styles";

const t = (key) => i18n.t(`boardShare.form.${key}`);

const PasswordInput = ({ value, onChange, error, autoFocus = false, disabled = false, readOnly = false }) => {
  const classes = useStyles();
  const [visible, setVisible] = useState(false);
  const { copied, copy } = useCopyFeedback(value, {
    copiedMessage: i18n.t("boardShare.created.passwordCopied"),
    failedMessage: i18n.t("boardShare.created.copyFailed"),
  });

  const generate = () => {
    onChange(generateStrongPassword());
    // A senha gerada aparece, para a pessoa ver o que vai enviar.
    setVisible(true);
  };

  return (
    <div className={classes.section}>
      <div className={classes.passwordRow}>
        <TextField
          className={classes.field}
          label={t("passwordLabel")}
          type={visible ? "text" : "password"}
          value={value}
          onChange={(e) => {
            if (!readOnly) onChange(e.target.value);
          }}
          variant="outlined"
          size="small"
          fullWidth
          autoFocus={autoFocus}
          disabled={disabled}
          error={Boolean(error)}
          helperText={readOnly ? undefined : error || t("passwordRule")}
          autoComplete="new-password"
          InputProps={{ readOnly }}
          inputProps={{ maxLength: 72, spellCheck: false, "aria-label": t("passwordLabel") }}
        />
        <div className={classes.passwordActions}>
          <Tooltip title={visible ? t("hide") : t("show")}>
            <button type="button" className={classes.iconBtn} onClick={() => setVisible((v) => !v)} aria-label={visible ? t("hide") : t("show")} disabled={disabled}>
              {visible ? <EyeOff /> : <Eye />}
            </button>
          </Tooltip>
          {!readOnly && (
            <Tooltip title={t("generate")}>
              <button type="button" className={classes.iconBtn} onClick={generate} aria-label={t("generate")} disabled={disabled}>
                <Wand2 />
              </button>
            </Tooltip>
          )}
          <Tooltip title={t("copyPassword")}>
            <span>
              <button
                type="button"
                className={`${classes.iconBtn} ${copied ? classes.copied : ""}`}
                onClick={copy}
                aria-label={t("copyPassword")}
                disabled={disabled || !value}
              >
                {copied ? <Check /> : <Copy />}
              </button>
            </span>
          </Tooltip>
        </div>
      </div>
    </div>
  );
};

export default PasswordInput;
